<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-date-picker v-model="formDatas.aseYearMonth" type="month" value-format="yyyyMM"
                        placeholder="选择年月" style="width: 140px" size="mini" clearable @change="partserch">
                    </el-date-picker>
                    <el-input v-model="formDatas.employeeName" placeholder="员工姓名" size="mini" clearable
                        style="width: 120px; margin-left: 10px" @keyup.enter.native="partserch">
                    </el-input>
                    <!-- 部门 -->
                    <el-input v-model="formDatas.department" placeholder="部门" size="mini" clearable
                        style="width: 120px; margin-left: 10px" @keyup.enter.native="partserch">
                    </el-input>
                    <!-- 处理状态 -->
                    <el-select v-model="formDatas.aseStatus" placeholder="处理状态" size="mini" clearable
                        style="width: 120px; margin-left: 10px" @change="partserch">
                        <el-option label="待处理" :value="1"></el-option>
                        <el-option label="已生成" :value="2"></el-option>
                        <el-option label="已发送" :value="3"></el-option>
                        <el-option label="生成失败" :value="4"></el-option>
                        <el-option label="发送失败" :value="5"></el-option>
                    </el-select>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <el-button type="primary" size="mini" style="margin-right: 10px;"
                        @click="bulkImport = true">批量导入</el-button>
                    <el-button type="danger" size="mini" style="margin-left: 10px"
                        @click="bulkMultiSend()">重新生成(生成失败时使用)</el-button>
                    <el-button type="success" size="mini" style="margin-left: 10px" @click="restart()">批量发送</el-button>

                    <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button>

                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <!-- <el-button type="success" size="mini" style="margin-right: 20px"
                        @click="BoxOpen">新增商品兑换收集</el-button> -->

                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="aseId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>

        </div>
        <!-- 批量导入 -->
        <el-dialog title="批量导入" :visible.sync="bulkImport" width="70%" :before-close="bulkImportClose"
            style="margin-left: 200px;">
            <div style="margin: 0 10px 10px;display: flex;">
                <el-upload class="upload-demo" action="#" accept=".xlsx,.xls" :on-change="updatabulk"
                    :auto-upload="false" ref="bulk" multiple>
                    <el-button size=" medium" type="danger">点击上传</el-button>

                </el-upload>
                <div>
                    <el-button type="primary"
                        @click="downloadFile('https://trainappsub.aojuai.com/excel/ajdataother/excel/salary.xlsx', '工资表')"
                        style="margin-left: 20%;height: 40px;">下载模板</el-button>
                </div>
            </div>
            <div>
                <ve-table :columns="columnsImport" :table-data="bulkData" :max-height="500" :border-x="true"
                    :border-y="true" :scrollWidth="10" row-key-field-name="dataIndex"
                    :cell-style-option="cellStyleOption" style="width: 100%" />
                <div v-show="bulkData.length == 0" class="empty-data">暂无数据</div>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="DingTalkShow" title="钉钉信息记录" width="90%" :before-close="DingTalkClose">
            <div style="margin: 10px;">
                <ve-table :columns="columnsDingTalk" :table-data="DingTalkData" :max-height="400" :border-x="true"
                    :border-y="true" :scrollWidth="10" row-key-field-name="asdmId" :cell-style-option="cellStyleOption"
                    style="width: 100%" />
                <div v-show="DingTalkData.length == 0" class="empty-data">暂无数据</div>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="isOutDiaLog" title="状态描述" width="90%" :before-close="OutDiaLogClose">
            <div style="margin: 10px;">
                <ve-table :columns="columnsOutDiaLog" :table-data="OutDiaLogData" :max-height="400" :border-x="true"
                    :border-y="true" :scrollWidth="10" row-key-field-name="aseId" :cell-style-option="cellStyleOption"
                    style="width: 100%" />
                <div v-show="OutDiaLogData.length == 0" class="empty-data">暂无数据</div>
            </div>
        </el-dialog>
        <el-image ref="scrImg" id="scrimg" :src="dialogImageUrl" alt="" fit="fill" style="width: 100%;height: 0;"
            :preview-src-list="scrList"></el-image>
    </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import {
    updateAjSalaryDingtalkMessageHandler, getAjSalaryEmployeeList, addAjefShopCollectionGoods, updateAjefShopCollectionGoods, getAjSalaryDingtalkMessageList,
    uploadAjSalaryEmployee, updateAjefShopBillRevokeHandler, updateAjSalaryEmployeeMultiSend, updateAjSalaryEmployeeMultiCreate,
} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            isOutDiaLog: false,
            OutDiaLogData: [],
            columnsOutDiaLog: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                
                {
                    field: "multiDes",
                    key: "multiDes",
                    title: "失败描述",
                    align: "center",
                    edit: false,
                    width: 200,
                },
                {
                    field: "aseYearMonth",
                    key: "aseYearMonth",
                    title: "日期",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "employeeName",
                    key: "employeeName",
                    title: "姓名",
                    align: "center",
                    edit: false,
                    width: 200,
                },
                {
                    field: "bankCardNumber",
                    key: "bankCardNumber",
                    title: "银行卡号",
                    align: "center",
                    edit: false,
                    width: 200,
                },

            ],
            theEmployeeDingId:'',
            DingTalkShow: false,
            DingTalkData: [],
            columnsDingTalk: [
                // {
                //     field: "",
                //     key: "checkbox",
                //     // type=checkbox
                //     type: "checkbox",
                //     fixed: 'left',
                //     title: "",
                //     width: 50,
                //     align: "center",
                // },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "conversationType",
                    key: "conversationType",
                    title: "会话类型",
                    align: "center",
                    edit: false,
                    width: 90,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.conversationType == 1 ? '单聊' : '群聊';
                    },

                },
                // {
                //     field: "msgId",
                //     key: "msgId",
                //     title: "消息ID（唯一标识）",
                //     align: "center",
                //     edit: false,
                //     width: 100,
                // },
                {
                    field: "msgtype",
                    key: "msgtype",
                    title: "消息类型",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                // {
                //     field: "senderId",
                //     key: "senderId",
                //     title: "发送者ID",
                //     align: "center",
                //     edit: false,
                //     width: 100,
                // },
                {
                    field: "senderNick",
                    key: "senderNick",
                    title: "发送者昵称",
                    align: "center",
                    edit: false,
                    width: 180,
                },
                {
                    field: "senderStaffId",
                    key: "senderStaffId",
                    title: "发送者员工ID",
                    align: "center",
                    edit: false,
                    width: 190,
                },
                {
                    field: "msgStr",
                    key: "msgStr",
                    title: "消息文本",
                    align: "center",
                    edit: false,
                    width: 420,
                },
                {
                    field: "createtime",
                    key: "createtime",
                    title: "记录创建时间",
                    align: "center",
                    edit: false,
                    width: 150,
                },
                {
                    field: "asdmStatus",
                    key: "asdmStatus",
                    title: "状态",
                    align: "center",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.asdmStatus === 1 ? <el-tag size="mini" type="warning">待处理</el-tag> :
                                        row.asdmStatus === 2 ? <el-tag size="mini" type="success">已处理</el-tag> :
                                            <el-tag size="mini" type="default">未知</el-tag>
                                }
                            </span>
                        );
                    },
                },
                // 操作
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 120,
                    fixed: 'right',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.asdmStatus === 1 ? <el-button size="mini" type="text" style="color: red" on-click={() => this.handleDingTalkStatus(row)}>处理</el-button> : ''
                                }

                            </span>
                        );
                    },
                }


            ],
            scrList: [],
            dialogImageUrl: '',
            totalCountBill: 1,
            formBill: {
                currentPage: 1,
                pageSize: 15
            },
            getAjefShopList_data: [],
            getAjefShopCollectionGoodsList_data: [],
            bulkImport: false,
            columnsImport: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "status",
                    key: "status",
                    title: "状态",
                    width: 150,
                    align: "center",
                    fixed: 'left',
                    filter: {
                        filterList: [
                            { value: 0, label: '成功', selected: false },
                            { value: 1, label: '失败', selected: false },
                            { value: 3, label: '信息不完整', selected: false }
                        ],
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            console.log(filterList);
                            const labels = filterList
                                .filter((x) => x.selected)
                                .map((x) => x.label);
                            this.searchByNameField(labels, 'status');
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.searchByNameField([]);
                        },
                        // max height
                        maxHeight: 120,
                    },
                },
                {
                    field: "statusMsg",
                    key: "statusMsg",
                    title: "状态备注",
                    width: 150,
                    align: "center",
                },
                {
                    field: "serialNumber",
                    key: "serialNumber",
                    title: "序号",
                    align: "center",
                    edit: false,
                    width: 80,
                },

                {
                    field: "aseYear",
                    key: "aseYear",
                    title: "年",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "aseYearMonth",
                    key: "aseYearMonth",
                    title: "月",
                    align: "center",
                    edit: false,
                    width: 120,
                },

                {
                    field: "employeeStatus",
                    key: "employeeStatus",
                    title: "状态",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "department",
                    key: "department",
                    title: "部门",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "employeeName",
                    key: "employeeName",
                    title: "姓名",
                    align: "center",
                    edit: false,
                    width: 120,
                },

                {
                    field: "entryDate",
                    key: "entryDate",
                    title: "入职时间",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "changeDate",
                    key: "changeDate",
                    title: "离职/转正/转岗时间",
                    align: "center",
                    edit: false,
                    width: 150,
                },
                {
                    field: "bankCardNumber",
                    key: "bankCardNumber",
                    title: "银行卡号",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "comprehensiveSalary",
                    key: "comprehensiveSalary",
                    title: "综合工资",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "scheduledWorkDays",
                    key: "scheduledWorkDays",
                    title: "应出勤天数",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "actualWorkDays",
                    key: "actualWorkDays",
                    title: "出勤天数",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "paidLeave",
                    key: "paidLeave",
                    title: "带薪假",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "newLeaveDays",
                    key: "newLeaveDays",
                    title: "新增假期",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "usedLeaveDays",
                    key: "usedLeaveDays",
                    title: "使用假期",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "accumulatedLeaveDays",
                    key: "accumulatedLeaveDays",
                    title: "累计可用余假",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "attendanceSalary",
                    key: "attendanceSalary",
                    title: "出勤薪资",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "performanceBonus",
                    key: "performanceBonus",
                    title: "绩效",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "absenceDeduction",
                    key: "absenceDeduction",
                    title: "缺勤扣款",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "companyCardFee",
                    key: "companyCardFee",
                    title: "公司号卡话费金额",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "phoneFeeSubsidy",
                    key: "phoneFeeSubsidy",
                    title: "话费补贴",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "courseResearchSubsidy",
                    key: "courseResearchSubsidy",
                    title: "普课/调研补贴",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "practicalSubsidy",
                    key: "practicalSubsidy",
                    title: "实战补贴",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "tutoringSubsidy",
                    key: "tutoringSubsidy",
                    title: "辅导补贴",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "stationedSubsidy",
                    key: "stationedSubsidy",
                    title: "驻点补贴",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "workshopSubsidy",
                    key: "workshopSubsidy",
                    title: "工作坊补贴",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "otherAdditions",
                    key: "otherAdditions",
                    title: "其他加项",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "payableSalary",
                    key: "payableSalary",
                    title: "应发工资",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "socialSecurity",
                    key: "socialSecurity",
                    title: "社保",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "providentFund",
                    key: "providentFund",
                    title: "公积金",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "otherDeductions",
                    key: "otherDeductions",
                    title: "其他减项",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "individualIncomeTax",
                    key: "individualIncomeTax",
                    title: "个税",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "actualSalary",
                    key: "actualSalary",
                    title: "实发工资",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "salaryImageUrl",
                    key: "salaryImageUrl",
                    title: "生成图片地址",
                    align: "center",
                    edit: false,
                    width: 120,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.salaryImageUrl ? (
                                        <el-image ref="scrImg" id="scrimg" src={row.salaryImageUrl} alt="" fit="scale-down" style="width: 50px;height: 50px;display: inline-block;"
                                            previewSrcList={[row.salaryImageUrl]}></el-image>

                                    ) : ''
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "salaryText",
                    key: "salaryText",
                    title: "发送文本信息",
                    align: "center",
                    edit: false,
                    width: 450,
                },
            ],
            bulkData: [],
            theRow: {},
            form2: {},
            diaAddReturn: false,
            diaDetail: false,
            tableDataDetail: [],
            dialogStatusValue: '',
            dialogStatus: false,
            key: 'aseId',
            dialog: false,
            edit: false,
            form: {
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: false,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 15,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,

            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "serialNumber",
                    key: "serialNumber",
                    title: "序号",
                    align: "center",
                    edit: false,
                    fixed: "left",
                    width: 80,
                },

                // {
                //     field: "aseYear",
                //     key: "aseYear",
                //     title: "年",
                //     align: "center",
                //     edit: false,
                //     width: 120,
                // },
                {
                    field: "aseYearMonth",
                    key: "aseYearMonth",
                    title: "月",
                    align: "center",
                    edit: false,
                    width: 120,
                },

                {
                    field: "employeeStatus",
                    key: "employeeStatus",
                    title: "状态",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "department",
                    key: "department",
                    title: "部门",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "employeeName",
                    key: "employeeName",
                    title: "姓名",
                    fixed: "left",
                    align: "center",
                    edit: false,
                    width: 120,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.employeeName ? (
                                        <el-link type="primary" onClick={() => this.showDingDingDetail(row)}>{row.employeeName}</el-link>
                                    ) : ''
                                }
                            </span>
                        );
                    },
                },

                {
                    field: "entryDate",
                    key: "entryDate",
                    title: "入职时间",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "changeDate",
                    key: "changeDate",
                    title: "离职/转正/转岗时间",
                    align: "center",
                    edit: false,
                    width: 150,
                },
                {
                    field: "bankCardNumber",
                    key: "bankCardNumber",
                    title: "银行卡号",
                    align: "center",
                    edit: false,
                    width: 180,
                },
                {
                    field: "comprehensiveSalary",
                    key: "comprehensiveSalary",
                    title: "综合工资",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "scheduledWorkDays",
                    key: "scheduledWorkDays",
                    title: "应出勤天数",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "actualWorkDays",
                    key: "actualWorkDays",
                    title: "出勤天数",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "paidLeave",
                    key: "paidLeave",
                    title: "带薪假",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "newLeaveDays",
                    key: "newLeaveDays",
                    title: "新增假期",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "usedLeaveDays",
                    key: "usedLeaveDays",
                    title: "使用假期",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "accumulatedLeaveDays",
                    key: "accumulatedLeaveDays",
                    title: "累计可用余假",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "attendanceSalary",
                    key: "attendanceSalary",
                    title: "出勤薪资",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "performanceBonus",
                    key: "performanceBonus",
                    title: "绩效",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "absenceDeduction",
                    key: "absenceDeduction",
                    title: "缺勤扣款",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "companyCardFee",
                    key: "companyCardFee",
                    title: "公司号卡话费金额",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "phoneFeeSubsidy",
                    key: "phoneFeeSubsidy",
                    title: "话费补贴",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "courseResearchSubsidy",
                    key: "courseResearchSubsidy",
                    title: "普课/调研补贴",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "practicalSubsidy",
                    key: "practicalSubsidy",
                    title: "实战补贴",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "tutoringSubsidy",
                    key: "tutoringSubsidy",
                    title: "辅导补贴",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "stationedSubsidy",
                    key: "stationedSubsidy",
                    title: "驻点补贴",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "workshopSubsidy",
                    key: "workshopSubsidy",
                    title: "工作坊补贴",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "otherAdditions",
                    key: "otherAdditions",
                    title: "其他加项",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "payableSalary",
                    key: "payableSalary",
                    title: "应发工资",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "socialSecurity",
                    key: "socialSecurity",
                    title: "社保",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "providentFund",
                    key: "providentFund",
                    title: "公积金",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "otherDeductions",
                    key: "otherDeductions",
                    title: "其他减项",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "individualIncomeTax",
                    key: "individualIncomeTax",
                    title: "个税",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "actualSalary",
                    key: "actualSalary",
                    title: "实发工资",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "salaryImageUrl",
                    key: "salaryImageUrl",
                    title: "生成图片地址",
                    align: "center",
                    edit: false,
                    width: 150,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.salaryImageUrl ? (
                                        <el-button type="text" size="mini" on-click={() => this.handlePictureCardPreview(row.salaryImageUrl)}>查看图片</el-button>

                                    ) : ''
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "salaryText",
                    key: "salaryText",
                    title: "发送文本信息",
                    align: "center",
                    edit: false,
                    width: 450,
                },
                {
                    field: "createtime",
                    key: "createtime",
                    title: "创建时间",
                    align: "center",
                    edit: false,
                    width: 160,
                },
                {
                    field: "createusername",
                    key: "createusername",
                    title: "创建人",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "aseStatusDes",
                    key: "aseStatusDes",
                    title: "处理状态描述",
                    align: "center",
                    edit: false,
                    width: 200,
                },
                {
                    field: "aseStatus",
                    key: "aseStatus",
                    title: "处理状态",
                    align: "center",
                    fixed: "right",
                    width: 120,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aseStatus == 1 ? <el-tag size="mini" type="danger">待处理</el-tag> :
                                        row.aseStatus == 2 ? <el-tag size="mini" type="warning">已生成</el-tag> :
                                            row.aseStatus == 3 ? <el-tag size="mini" type="success">已发送</el-tag> :
                                                row.aseStatus == 4 ? <el-tag size="mini" type="danger">生成失败</el-tag> :
                                                    row.aseStatus == 5 ? <el-tag size="mini" type="danger">发送失败</el-tag> :
                                                        <el-tag size="mini" type="default">未知</el-tag>
                                }
                            </span>
                        );
                    },
                },

            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                dmDelete: 1,
                currentPage: 1,
                pageSize: 15,
            },

            bulkDataCopy: [],
            sitId: '',
            importData: {},

        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;

        this.getList();
    },
    mounted() { },
    methods: {
        OutDiaLogClose() {
            this.isOutDiaLog = false;
            this.OutDiaLogData = [];
        },  
        getDingtalkData() {
            getAjSalaryDingtalkMessageList({senderStaffId: this.theEmployeeDingId}).then(res => {
                this.DingTalkData = res.data;
            })
        },
        handleDingTalkStatus(row) {
            this.$confirm("是否确定要处理吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjSalaryDingtalkMessageHandler({ asdmId: row.asdmId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "处理成功!",
                            });

                            this.getDingtalkData()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        showDingDingDetail(row) {
            if (!row.employeeDingId) return;
            this.theEmployeeDingId = row.employeeDingId;
            getAjSalaryDingtalkMessageList({ senderStaffId: row.employeeDingId }).then(res => {
                this.DingTalkData = res.data;
                this.DingTalkShow = true;
            })

        },
        DingTalkClose() {
            this.DingTalkShow = false;
            this.DingTalkData = [];
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file;
            this.scrList.push(file)
            this.$refs.scrImg.clickHandler()
        },
        handleDown(row) {
            this.$confirm("是否确定要暂停吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjefShopCollectionGoodsDown({ acrsId: row.acrsId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "暂停成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleUp(row) {
            this.$confirm("是否确定要发布吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjefShopCollectionGoodsUp({ acrsId: row.acrsId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        downloadFile(url, name) {//下载
            if (!url) {
                return
            }
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.onload = function () {
                document.body.removeChild(link);
            };
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
        },
        async updatabulk(file, fileList) {
            console.log(file, fileList);
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadAjSalaryEmployee(Data).then(res => {
                console.log("上传成功")
                this.loadings.close()
                this.bulkData = res.data.data;
            })
        },
        bulkImportClose(done) {
            done();
            this.bulkData = [];
            this.$nextTick(() => {
                this.getList()
            })
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        Out2() {
            var s = qs.stringify(this.formDatas);
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/ajef-certificate-record-statistics/exportAjefCertificateRecordStatisticsYearShop',
                data: s,
                // withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'useref': window.localStorage.getItem('Qy_token')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '财务统计记录-商户.xlsx');
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })
        },
        Out() {
            var s = qs.stringify(this.formDatas);
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/aj-salary-employee/exportAjSalaryEmployee',
                data: s,
                // withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'userid': window.localStorage.getItem('Sy_userId')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '工资条(一).xlsx');
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })
        },
        bulkImportClick() {
            if (this.sitId == '') {
                this.$message({
                    showClose: true,
                    message: "请导入资料",
                    type: 'danger'
                });
            } else {
                uploadImportAjAssetsKey({
                    sitId: this.sitId
                }).then(res => {
                    this.getList()
                    this.bulkImport = false;
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.sitId = '';
                    this.$refs['bulk'].clearFiles()
                    this.$message({
                        type: 'success',
                        message: '导入成功!'
                    });
                })
            }

        },

        handleStatus(row) {
            this.theRow = row;
            this.dialogStatusValue = row.aakStatus;
            this.dialogStatus = true;
        },
        sureStatus() {
            updateAjAssetsFireEquipmentStatus({ acrsId: this.theRow.acrsId, aakStatus: this.dialogStatusValue }).then(res => {
                if (res.data) {
                    this.$message({
                        type: "success",
                        message: "修改成功!",
                    });
                    this.getList();
                    this.dialogStatusValue = ''
                }
            })
            this.dialogStatus = false;
        },
        closeStatus() {
            this.dialogStatus = false;
            this.dialogStatusValue = ''
        },
        bulkMultiSend() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        this.openLoading()
                        updateAjSalaryEmployeeMultiCreate({ aseIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            this.loadings.close()
                            this.OutDiaLogData = res.data;
                            this.isOutDiaLog = true;
                            this.$message({
                                type: "success",
                                message: "成功!",
                            });
                            this.checkboxOption.selectedRowKeys = [];
                            this.selectedRowKeysCollection = [];
                            this.partserch()
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },

        // 批量删除
        restart() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        this.openLoading()
                        updateAjSalaryEmployeeMultiSend({ aseIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            this.loadings.close()
                              this.OutDiaLogData = res.data;
                            this.isOutDiaLog = true;
                            this.$message({
                                type: "success",
                                message: "成功!",
                            });
                            this.checkboxOption.selectedRowKeys = [];
                            this.selectedRowKeysCollection = [];
                            this.partserch()
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },

        handleDelete(row) {
            this.$confirm("是否确定要处理吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjefShopBillRevokeHandler({ acrsId: row.acrsId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "处理成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const newForm = JSON.parse(JSON.stringify(this.form))
                        if (newForm.acrAmount == 0) {
                            newForm.acrAmount = newForm.acrAmount2
                        }
                        addAjefShopCollectionGoods(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjefShopCollectionGoods(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },

        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.acrsId = row.acrsId
                    console.log(jsonObj);
                    updateAjefShopCollectionGoods(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjSalaryEmployeeList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAjSalaryEmployeeList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAjSalaryEmployeeList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>